import axios from 'axios'

let role = {}
//带分页
role.find = params => {
  return axios.get('/sys/role/find', {params})
}
//不带分页
role.findNotPage = params => {
  return axios.get('/sys/role/find1', {params})
}
role.delRole= params => {
  return axios.post('/sys/role/dels', params)
}
role.saveRole = params => {
  return axios.post('/sys/role/update', params)
}
role.findUserByRoleId = params => {
  return axios.get('/sys/role/users', {params})
}
role.list = params => {
  return axios.get('/sys/role/list', {params})
}
role.findResourceByRoleId = params => {
  return axios.get('/sys/perm/role', {params})
}
//分配权限
role.saveResource = params => {
  return axios.post('/sys/perm/save', params)
}
export default role



// WEBPACK FOOTER //
// ./src/api/role.js